/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import config from 'js/app/config';

import { Link, PageGridContainer, Typography2 } from '@coursera/cds-core';
import { ExternalLinkIcon } from '@coursera/cds-icons';

import LazyImgix from 'bundles/page/components/shared/LazyImgix';
import CertificateAndBenefitsText from 'bundles/unified-description-page-common/components/shared/CertificateAndBenefitsText';
import Section from 'bundles/unified-description-page-common/components/shared/Section';

import ProjectBenefitsImage from 'images/unified-description-page/portfolio-benefits-background.png';

import _t from 'i18n!nls/xdp';

type Props = {
  description: string;
  title: string;
};
const styles = {
  description: css`
    padding-bottom: 20px;
  `,
  imageContainerDesktop: css`
    position: absolute;
    right: 43px;
    top: 30%;
    transform: translateY(-50%);
    height: 215px;
    width: 320px;
    background: var(--cds-color-neutral-background-primary);
    box-shadow: 0 3px 17px var(--cds-color-darken-100);
    border-radius: 7px;

    @media (max-width: 1150px) {
      right: 50%;
      transform: translate(50%, -50%);
    }
  `,
  mobileBenefitsImage: css`
    box-shadow: 0 4px 20px var(--cds-color-darken-100);
    height: 165px;
    width: 259px;
  `,
};

const PortfolioBenefitsModule = ({ description, title }: Props) => {
  return (
    <Section>
      <PageGridContainer>
        <CertificateAndBenefitsText
          title={title}
          description={
            <React.Fragment>
              <Typography2 component="p" variant="bodyPrimary" css={styles.description}>
                {description}
              </Typography2>
              <Link
                href={`${config.url.base}account-profile`}
                target="_blank"
                variant="quiet"
                typographyVariant="bodyPrimary"
                icon={<ExternalLinkIcon />}
                iconPosition="after"
              >
                {_t('Manage my profile')}
              </Link>
            </React.Fragment>
          }
          mobileImage={
            <LazyImgix
              src={ProjectBenefitsImage}
              alt=""
              maxWidth={259}
              maxHeight={165}
              css={styles.mobileBenefitsImage}
            />
          }
          desktopImage={
            <div css={styles.imageContainerDesktop}>
              <LazyImgix src={ProjectBenefitsImage} alt="" maxWidth={333} maxHeight={215} />
            </div>
          }
        />
      </PageGridContainer>
    </Section>
  );
};

export default PortfolioBenefitsModule;
